module.exports = __webpack_public_path__ + "static/media/background-shapes.4366a701.png";